import { Component } from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {LoadingService} from "../services/LoadingService";
import {TOAST_TYPE} from "../constants/Tpiq.constants";
import {ActivatedRoute, Router} from "@angular/router";
import {ToastService} from "../services/Toast.service";
import {SwitchBoard} from "../services/SwitchBoard";
import {LoginService} from "../services/Login.service";
import {LogoService} from "../services/LogoService";

declare var jQuery: any;

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
  password: string;
  notValid = false;
  confirmPassword: string;
  routeSub: any;
  token: string;
  logoBg: any;
  logoSub: any;
  orgName: string;
  smallLogo = './images/logo.png';
  logoSubscription: any;

  constructor(private _router: Router, private _toastService: ToastService, private _route: ActivatedRoute,
              private loginService: LoginService, private loadingService: LoadingService, private switchBoard: SwitchBoard,
              private logoService: LogoService) {
    const base = this;
    this.orgName = this.logoService.getOrg();
    this.routeSub = this._route.params.subscribe(params => {
      this.token = params.token;
    });

    this.logoSubscription = this.switchBoard.onLogosReady.subscribe(logoObj => {
      if (logoObj.loginLogoUrl){
        base.logoBg = {
          background: 'url("' + logoObj.loginLogoUrl + '") center center contain no-repeat'
        };
      }
    });
  }

  ngOnDestroy(){
    this.routeSub.unsubscribe();
    if (this.logoSub){
      this.logoSub.unsubscribe();
    }
    if (this.logoSubscription){
      this.logoSubscription.unsubscribe();
    }
  }

  handleError(err){

  }
  submit($event){
    $event && $event.preventDefault();
    if (this.checkPasswordsMatch()){
      const data = {
        action: 'reset',
        password: this.password,
        token: this.token
      };
      this.loadingService.triggerLoadingEvent(true);
      this.loginService.resetPassword(data).subscribe(res => {
        this.loadingService.triggerLoadingEvent(false);
        if (res){
          this._toastService.pop(TOAST_TYPE.success, 'Password Reset was Successful');
          this.handleLogos();
          this._router.navigate(['login']);
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this._toastService.pop(TOAST_TYPE.error, 'Failed To Reset Password');
      });
    }
  }

  checkPasswordsMatch() {
    if (this.password && this.confirmPassword && this.password === this.confirmPassword) {
      this.notValid = false;
      return true;
    }else {
      this.notValid = true;
      return false;
    }
  }

  handleLogos(){
    const base = this;
    this.logoService.getOrgLogos(base.orgName).subscribe(response => {
      this.logoService.setLogoUrls(response);
      this.switchBoard.onLogosReady.next(response);
      if (response.faviconUrl){
        jQuery('#favicon').attr('href', response.faviconUrl);
        this.smallLogo = response.faviconUrl;
      } else  if (this.orgName === 'stag-app' || this.orgName === 'app') {
        let logoObj = {
          faviconUrl: 'https://static.taxplaniq.com/futurefirm/favicon_new.png',
          loginLogoUrl: 'https://static.taxplaniq.com/test-taxplaniq/new_tpiq_logo.png'
        };
        this.logoService.setLogoUrls(logoObj);
        let tpiqFavLogo = 'https://static.taxplaniq.com/futurefirm/favicon_new.png';
        jQuery('#favicon').attr('href', tpiqFavLogo);
        this.smallLogo = tpiqFavLogo;
      }
    }, error => {
    });
  }

}
